import Button from "./Button";

export const BackButton = ({
  handlePrevStep,
  className,
  small,
}: {
  handlePrevStep: () => void;
  className?: string;
  small?: boolean;
}) => (
  <Button
    variant="secondary"
    type="button"
    onClick={() => {
      window.scrollTo(0, 0);
      handlePrevStep();
    }}
    className={className}
    small={small}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
      <path
        fill="#2A3D8C"
        d="M13.163 15.587a.939.939 0 1 1-1.328 1.328l-6.25-6.25a.938.938 0 0 1 0-1.328l6.25-6.25a.94.94 0 1 1 1.328 1.328L7.578 10l5.585 5.587Z"
      />
    </svg>
    Back to Dates
  </Button>
);
